module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/main_card_background_with_quests_big.81fb2180.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/main_card_background_with_quests_big.jpg
// module id = 3016
// module chunks = 11